{
  "name": "sabre-client",
  "version": "0.2.4",
  "description": "Sabre Node.js SDK",
  "keywords": [
    "sabre",
    "client",
    "devStudio",
    "rest"
  ],
  "homepage": "https://github.com/CarlosIvanSoto/sabre#readme",
  "bugs": {
    "url": "https://github.com/CarlosIvanSoto/sabre/issues"
  },
  "repository": {
    "type": "git",
    "url": "git+https://github.com/CarlosIvanSoto/sabre.git"
  },
  "license": "MIT",
  "author": "Carlos Ivan Soto <csoto_99@outlook.com>",
  "type": "module",
  "main": "./dist/index.cjs",
  "module": "./dist/index.js",
  "types": "./dist/index.d.ts",
  "files": [
    "dist/**"
  ],
  "exports": {
    ".": {
      "import": "./dist/index.js",
      "require": "./dist/index.cjs"
    }
  },
  "scripts": {
    "build": "tsup",
    "prepublishOnly": "npm run build",
    "test": "jest --passWithNoTests",
    "test:watch": "jest --watch",
    "lint": "eslint . --ext .ts --report-unused-disable-directives --max-warnings 0",
    "type-check": "tsc --noEmit",
    "example:auth-atk": "node --env-file=.env --import=tsx examples/auth-atk.ts",
    "example:search-shop": "node --env-file=.env --import=tsx examples/search-shop.ts"
  },
  "devDependencies": {
    "@eslint/js": "^9.38.0",
    "@types/jest": "^30.0.0",
    "@types/node": "^24.8.1",
    "eslint": "^9.38.0",
    "jest": "^30.2.0",
    "ts-jest": "^29.4.5",
    "ts-node": "^10.9.2",
    "tsup": "^8.5.0",
    "tsx": "^4.20.6",
    "typescript": "^5.9.3",
    "typescript-eslint": "^8.46.1"
  }
}
